// removed by extract-text-webpack-plugin
module.exports = {"summary":"Summary__summary___2zb4q","title":"Summary__title___27_co","number":"Summary__number___NV5xA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Orders/Summary/Summary.scss
// module id = 1239
// module chunks = 1